import { useContext, useMemo, useState, type ComponentProps } from "react"

import { TableDisplayContext } from "@/contexts/TableDisplayContext"
import {
  describeTableFilters,
  type TableExportScope,
} from "@/utils/csv/tableCsvColumns"

/** Keeps table-owned display controls in the owning toolbar without moving table state. */
export function TableDisplayScope({
  children,
  search,
  filterControls,
  filters,
  ...props
}: ComponentProps<"div"> & TableExportScope) {
  const [target, setTarget] = useState<HTMLDivElement | null>(null)
  const value = useMemo(
    () => ({
      target,
      setTarget,
      exportFilters: describeTableFilters({ search, filterControls, filters }),
    }),
    [target, search, filterControls, filters],
  )
  return (
    <TableDisplayContext.Provider value={value}>
      <div {...props}>{children}</div>
    </TableDisplayContext.Provider>
  )
}

export function TableDisplaySlot() {
  const scope = useContext(TableDisplayContext)
  return scope ? (
    <div
      ref={scope.setTarget}
      className="flex shrink-0 items-center gap-2 empty:hidden"
    />
  ) : null
}
